import { Route, Routes } from "react-router-dom";

import About from "../pages/About";
import Category from "../pages/Category";
import Cities from "../pages/Cities";
import City from "../pages/City";
import Home from "../pages/Home";
import Item from "../pages/Item";
import NotFound from "../pages/NotFound";
import SearchPage from "../pages/SearchPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/city" element={<Cities />} />
      <Route path="/city/:city" element={<City />} />
      <Route path="/city/:city/:category" element={<Category />} />
      <Route path="/city/:city/:category/:item" element={<Item />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/about" element={<About />} />
      {/* <Route path="/contact" element={<Contact />} /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
